let chatOverviewContainer = $('#chat-overview-container');
let colChatOverview = $('#colChatOverview');
let chatOverview = colChatOverview.find('#chatOverview');
// let chatButtons = chatOverview.find('.chat-buttons-wrapper');

let colChat = $('#colChatContainers')
let panes = colChat.find('#chatContainers');
let checkMessagesInterval = 60000;
let sending = false;

$('.chat-container .messages').each(function (k, item) {
    updateScroll($(item));
});
autoSizeEvent($('.chat-container textarea'));

$(document).on('change', '.messageAttachementBtn input', function () {
    let filenames = '';
    for (let k in this.files) {
        if (this.files.hasOwnProperty(k)) {
            filenames += '<span class="badge badge-primary fa-1x mr-2" data-file-key="' + k + '">' + this.files[k].name + '</span>';
        }
    }

    $(this).closest('.message-input').find('.chat-message-attachment-labels .uploads').html('').html(filenames);
})

$(document).on('click', '.chat-file-presets .chat-file-preset', function () {
    let filePreset = $(this);
    let messageInput = $(this).closest('.chat-container').find('.message-input');
    let presetPreview = messageInput.find('.chat-message-attachment-labels .presets');
    if (presetPreview.find('[data-setting="' + filePreset.data('setting') + '"]').length === 0) presetPreview.html(presetPreview.html() + '<span class="badge badge-primary fa-1x mr-2" data-setting="' + filePreset.data('setting') + '">' + filePreset.data('name') + '</span>');

    let input = messageInput.find('[name="file_presets"]');
    let presetInputData;

    if (input.val().length) {
        presetInputData = JSON.parse(input.val());
    } else {
        presetInputData = {};
    }

    presetInputData[filePreset.data('setting')] = filePreset.data('setting');
    input.val(JSON.stringify(presetInputData));
});

$(document).on('click', '.chat-message-attachment-labels span.badge', function (e) {
    let fileLabel = $(this)
    fileLabel.closest('.message-input').find('.messageAttachementBtn input').val('')
    fileLabel.closest('.message-input').find('input[name="file_presets"]').val('')
    fileLabel.closest('.chat-message-attachment-labels').find('.presets span').siblings().remove();
    fileLabel.closest('.chat-message-attachment-labels').find('.uploads span').siblings().remove();

    fileLabel.remove()
})

$(document).on('click', '.js-accommodation-overview-preset', function () {
    let messageInput = $(this).closest('.chat-container').find('.message-input');
    let input = messageInput.find('[name="message"]');
    input.val($(this).attr('data-msg'));

    sendMessageAjax(this);
});

$(document).on('click', '.sendMessage', function (e) {
    sendMessageAjax(this);
});

$(window).on('resize', () => {
    checkMobileView()
})
$(window).on('load', () => {
    if ($(document).find('body').width() <= 768) {
        checkMobileView()
        let messages = $('.chat-container').find('.messages')
        updateScroll(messages);
    }
})

$(document).on('keydown', '.message-input textarea', function (e) {
    if (e.ctrlKey && e.keyCode === 13) {
        sendMessageAjax(this);
    }
});

if (chatOverviewContainer.length) {
    chatOverview.on('shown.bs.tab click', (e) => {
        if (e.type !== 'click' || panes.find('.tab-pane.active').length) {
            loadChat(e);
        }
    });

    let activeChat = $('.nav-link.active');

    if (activeChat.length) {
        $('.nav-pills').animate({scrollTop: activeChat.offset().top - 100}, 0);
    }

    /**
     * Function for mobile to return to overview.
     */
    function backButtonClick() {
        chatOverviewContainer.find('.header-chat-overview').removeClass('d-none').addClass('d-block')
        colChatOverview.removeClass('d-none').addClass('d-block');
        colChat.addClass('d-none').removeClass('d-block');
    }

    $('.backButton').click(backButtonClick);
    // window.backbuttonListener.listen('back-button', backButtonClick, true);
}

$('.chat-container').each(function () {
    let options = JSON.parse(atob($(this).data('options')))
    if (options.checkMessages) {
        setInterval(() => {
            checkMessagesAjax($(this));
        }, checkMessagesInterval);
    }
})

// on click showBookingDetailsButton
// resources/views/components/chat/includes/booking-details-modal.blade.php
$(document).on('click', '.showBookingDetailsButton', function (event, item) {
    let chat = $(event.currentTarget).closest('.chat-container');
    let options = JSON.parse(atob(chat.data('options')));
    let showDetailsButton = $(this);

    let modal = $('#bookingDetailsModal');

    $.ajax(options.routes.bookingDetails, {
        type: 'GET',
        dataType: 'JSON',
        data: {},
        success: (result) => {
            // if result.bookingDetails is empty, show error message
            if (result.bookingDetails === '') {
                modal.find('.modal-body').html('Er zijn nog geen boekingsgegevens beschikbaar.');
                modal.modal('show');
                window.hideAllTooltips();
                return;
            }

            if (result.url !== '') {
                // add url to #bookingDetailsPageUrlButton
                $('#bookingDetailsPageUrlButton').attr('href', result.url);
            }

            $html = result.bookingDetails.original.bookingDetails;

            // add to modal body
            modal.find('.modal-body').html($html);

            // find modal dismiss button
            let dismissButton = modal.find('.modal-footer button[data-dismiss="modal"]');

            // if there is a dismiss button
            if (dismissButton.length) {
                // change text
                dismissButton.text(result.btnTranslations.back);
            }

            $('#bookingDetailsPageUrlButton').html('<i class="fas fa-home"></i> ' + result.btnTranslations.view);

        }, error: (error) => {
            handleError(chat, error, options)
            $(this).prop('disabled', false);
        }
    });


    modal.modal();
});

$(document).on('click', '.cancelOptionButton', function (event, item) {
    let chat = $(event.currentTarget).closest('.chat-container');
    let options = JSON.parse(atob(chat.data('options')));
    let chatButton = $(this);

    let cancelModal = $('#cancel-option-modal');

    $('button.btn-success', cancelModal).off('click keydown').on('click keydown', () => {
        let modalButton = cancelModal.find('.prevent-double-click');
        window.preventDoubleClick(modalButton)
        $.ajax(options.routes.addMessage, {
            type: 'POST', dataType: 'JSON', data: {
                cancelOption: 1,
                message: $('textarea', cancelModal).val()
            }, success: (result) => {
                chatButton.prop('disabled', true);
                chatButton.addClass('disabled');
                formatIncomingMessage(chat, result, options, true)
                cancelModal.modal('hide');

                let optionOpenBlock = chat.find('.option-open-block');
                let optionDeniedBlock = chat.find('.option-denied-block');

                optionOpenBlock[0].classList.add('d-none');
                optionDeniedBlock[0].classList.remove('d-none');

                if (result.filteredWords !== null && result.filteredWords !== undefined) {
                    let wordList = $('#chat-filtered-words-modal-list');
                    if (wordList.length) {
                        wordList.html('');

                        // Show custom explanations based on what was wrong.
                        wordList.closest('.modal').find('.custom-explanation,.custom-icon').addClass('d-none');
                        if (result.item.contains_phone == true) {
                            $('#phone-explanation,#phone-icon').removeClass('d-none')
                        } else {
                            if (result.item.contains_website == true) {
                                $('#website-explanation,#website-icon').removeClass('d-none')
                            } else {
                                if (result.item.contains_accommodation == true) {
                                    $('#accommodation-explanation,#accommodation-icon').removeClass('d-none')
                                } else {
                                    if (result.item.contains_email == true) {
                                        $('#email-explanation,#email-icon').removeClass('d-none')
                                    }
                                }
                            }
                        }


                        // Show modal.
                        wordList.closest('.modal').modal('show');
                        window.hideAllTooltips();
                    }
                }

            }, error: (error) => {
                handleError(chat, error, options)
                $(this).prop('disabled', false);
            }
        });
    });

    cancelModal.modal();
});

/**
 *
 */
$(document).on('click', '.optionToBookingButton', function (event, item) {
    let chat = $(event.currentTarget).closest('.chat-container');
    let options = JSON.parse(atob(chat.data('options')));
    let chatButton = $(this);
    let o2bModal = $('#option-to-booking-modal');
    let state = 'free';
    let settings = null;

    /** /chat/booking/{va_id}/available Frontend\ChatController@available */
    $.ajax(options.routes.addMessage + '/available', {
        type: 'GET',
        dataType: 'JSON',
        data: {},
        success: (result) => {
            if (result.available) {
                if (result.servicecosts) {
                    o2bModal.addClass('servicecosts');
                    o2bModal.removeClass('no-servicecosts');
                } else {
                    o2bModal.addClass('no-servicecosts');
                    o2bModal.removeClass('servicecosts');
                }

                $('.option2booking-content-occupied', o2bModal).hide();
                if (result.servicecosts) {
                    $('.option2booking-content-free-servicecosts', o2bModal).show();
                    $('.option2booking-content-free', o2bModal).hide();
                    $('button.btn-success', o2bModal).text($('button.btn-success', o2bModal).attr('data-option2booking-content-free-servicecosts'));
                } else {
                    $('.option2booking-content-free-servicecosts', o2bModal).hide();
                    $('.option2booking-content-free', o2bModal).show();
                    $('button.btn-success', o2bModal).text($('button.btn-success', o2bModal).attr('data-option2booking-content-free'));
                }
                if ((result.serviceCostsAmount ?? null) !== null) {
                    $('button.hjufdskl', o2bModal).html(result.serviceCostsAmount);
                }

                $('.vouchers-overview-first-payment', o2bModal).show();
            } else {
                $('.option2booking-content-free', o2bModal).hide();
                $('.option2booking-content-occupied', o2bModal).show();
                $('button.btn-success', o2bModal).text($('button.btn-success', o2bModal).attr('data-option2booking-content-occupied'));
                $('.vouchers-overview-first-payment', o2bModal).hide();
            }

            settings = result?.settings;

            // show or hide the text for cancellation insurance
            let CancellationInsuranceAddAfterBooking = $('#cancellation-insurance-add-after-booking');
            if (result?.settings?.offer_cancellation_insurance_actively && result?.settings?.widget_internal) {
                CancellationInsuranceAddAfterBooking.show();
                $('#option-cancellation-insurance-modal button[data-dismiss="modal"]').hide();
            } else {
                CancellationInsuranceAddAfterBooking.hide();
            }

            $('#modalBookingDetails').html(result.bookingDetails ?? '');

            if ((result.amount !== undefined) && (parseInt(result.amount) > 0)) {
                let amount = result.amount - result.voucher.voucher_amount;
                let num = Math.round((Number(amount) + Number.EPSILON) * 100) / 100;
                let str = num.toFixed(2).replace('.', ',');
                $('.hkjgytrgug').html('&euro; ' + str);
            }

            if ((result.deposit !== undefined) && (parseInt(result.deposit) > 0)) {
                let num2 = Math.round((Number(result.deposit) + Number.EPSILON) * 100) / 100;
                let str2 = num2.toFixed(2).replace('.', ',');
                $('.fjheksl').html(str2);
            }

            $('button.btn-success', o2bModal).off('click keydown').on('click keydown', () => {
                approveOption(chat, chatButton, settings);
                o2bModal.modal('hide');
            });
        }, error: (error) => {
            handleError(chat, error, options)
            $(this).prop('disabled', false);
        }
    });


    o2bModal.modal();
})

/**
 * Send the confirmation to change an option to a booking.
 *
 * @param chat
 * @param chatButton
 */
function approveOption(chat, chatButton, settings) {

    let options = JSON.parse(atob(chat.data('options')));
    /** /chat/booking/{va_id}  Frontend\ChatController@store*/
    $.ajax(options.routes.addMessage, {
        type: 'POST',
        dataType: 'JSON',
        data: {
            approveOption: 1
        }, success: (result) => {
            if ((result.checkout_url !== undefined) && (result.checkout_url !== null)) {
                document.location.href = result.checkout_url;
                return;
            }

            chatButton.prop('disabled', true);
            chatButton.addClass('disabled');
            formatIncomingMessage(chat, result, options, true);

            // hide .cancel-option add class d-none
            let cancelOption = chat.find('.cancel-option');
            cancelOption.addClass('d-none');

            if (settings ?? false) {
                showInsuranceModel(settings, options);
            }

        }, error: (error) => {
            handleError(chat, error, options)
            $(this).prop('disabled', false);

            // hide .cancel-option add class d-none
            let cancelOption = chat.find('.cancel-option');
            cancelOption.addClass('d-none');
        }
    });
}

$(document).on('click', '.insuranceCallToAction', function (event) {
    let chat = $(event.currentTarget).closest('.chat-container');
    let options = JSON.parse(atob(chat.data('options')));
    let chatButton = $(this);
    let o2bModal = $('#option-to-booking-modal');
    let state = 'free';
    let settings = {
        cancellation_insurance: chatButton.data('cancellation_insurance'),
        cancellation_insurance_interest: chatButton.data('cancellation_insurance_interest'),
        cancellation_insurance_premium: chatButton.data('cancellation_insurance_premium'),
        offer_cancellation_insurance_actively: chatButton.data('offer_cancellation_insurance_actively'),
        widget_internal: chatButton.attr('data-widget_internal'),
    };
    showInsuranceModel(settings, options);
})

function showInsuranceModel(settings, options, o2bModal = null) {
    if (!settings.offer_cancellation_insurance_actively || !settings.widget_internal) {
        return
    }
    let cancellationInsuranceModal = $('#option-cancellation-insurance-modal');
    let insuranceYes = $('#cancellation_insurance')
    let insuranceNo = $('#cancellation_insurance-no');
    let displayInsuranceInCosts = $('#cancellation-insurance-costs');
    let birthday = cancellationInsuranceModal.find('#birthday');
    let birthdayBlock = $('#cancellation_insurance-birthday');
    o2bModal = $('#option-to-booking-modal');

    if (settings.cancellation_insurance_premium) {
        $('span.premium', cancellationInsuranceModal).html('(' + Intl.NumberFormat('nl-NL', {
            style: 'currency',
            currency: 'EUR'
        }).format(
            settings.cancellation_insurance_premium,
        ) + ')');
    }

    if (settings?.birthday) {
        birthday.val(settings.birthday);
    }

    if (settings.cancellation_insurance || settings.cancellation_insurance_interest) {
        $('.cancellation-insurance-choice-to-yes', cancellationInsuranceModal).hide();
        $('.cancellation-insurance-choice-to-no', cancellationInsuranceModal).show();
        insuranceYes.prop('checked', true);
        insuranceNo.prop('checked', false);

        birthdayBlock.show();
    } else {
        $('.cancellation-insurance-choice-to-yes', cancellationInsuranceModal).show();
        $('.cancellation-insurance-choice-to-no', cancellationInsuranceModal).hide();
        insuranceNo.prop('checked', false);
        insuranceYes.prop('checked', false);

        birthdayBlock.hide();
    }
    $('button.btn-success.confirm', cancellationInsuranceModal).off('click keydown').on('click keydown', () => {
        $.ajax(options.routes.addMessage + '/cancellation-insurance', {
            type: 'POST',
            data: {
                'birthday': birthday.prop('value'),
                'cancellation_insurance': insuranceYes.prop('checked')
            },
            success: (result) => {
                location.reload();
            },
            error: (result) => {
                let response = JSON.parse(result.responseText);
                alert(response.errors.birthday.join(', '));
            }
        });
    });

    cancellationInsuranceModal.modal('show');
    window.hideAllTooltips();

    $('#cancellation_insurance, #cancellation_insurance-no', cancellationInsuranceModal).off('click keydown').on('click keydown', function () {
        let btn = $(this);

        // Yes, insurance wanted.
        if (btn.is(insuranceYes)) {
            insuranceNo.prop('checked', false);
        }

        // No, insurance not wanted.
        if ((btn.is(insuranceNo))) {
            insuranceYes.prop('checked', false);
        }
    });

    // Open the more info modal.
    $('#cancellation_insurance-modal-btn').off('click keydown').on('click keydown', () => {
        $('#cancellationInsuranceModal').modal('show');
        window.hideAllTooltips();
    });
}

// on #cancellation_insurance-no click and unchecked
$(document).on('click', '#cancellation_insurance-no', function () {
    let birthdayBlock = $('#cancellation_insurance-birthday');
    birthdayBlock.slideUp();
});

// on #cancellation_insurance click and checked
$('#cancellation_insurance, #cancellation_insurance_interest').on('click keydown', function () {
    let birthdayBlock = $('#cancellation_insurance-birthday');
    birthdayBlock.slideDown();
});

$(document).on('click', '.sendReservationLink:not(:disabled)', (event, item) => {
    let button = $(event.currentTarget)
    let chat = button.closest('.chat-container');
    let options = JSON.parse(atob(chat.data('options')));
    let optionLink = button.hasClass('sendOptionLink');

    button.prop('disabled', true).attr('disabled', true)
        .text(optionLink ? 'Optieverzoek verstuurd' : 'Boekingsverzoek verstuurd')
        .addClass('disabled');

    $.ajax(options.routes.addMessage, {
        type: 'POST', dataType: 'JSON', data: {
            reservationLink: 1,
            message: optionLink ? `Wij nodigen u uit om een optie te plaatsen. Klik hiervoor op de groene button hieronder.` : `Wij nodigen u uit om ons vakantiehuis te boeken. Klik hiervoor op de groene button hieronder.`
        }, success: (result) => {
            formatIncomingMessage(chat, result, options)
        }, error: (error) => {
            handleError(chat, error, options)
        }
    });
});


//in main window


/** Resize of widget modal */
window.addEventListener('message', function (message) {
    if (isFinite(message.data)) {
        let modal = $('#chatWidgetModal');
        modal.find('.modal-body iframe').height(Math.ceil(message.data) + 'px');
        modal.find('.modal-body').height(modal.find('iframe').height());
        modal.modal('handleUpdate');
    }
});

function appendToMessages(messages, append) {
    let cta = messages.find('#call-to-action');
    if (cta.length) {
        append.insertBefore(cta);
    } else {
        messages.append(append);
    }
}

function strip(html) {
    let doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.body.textContent || "";
}

function updateScroll(messages) {
    messages[0].scrollTop = messages[0].scrollHeight;
}

function autoSizeEvent(elem) {
    let autosize = window.autosize(elem);
    elem.on('autosize:resized', function () {
        let messages = $(this).closest('.chat-container').find('.messages');
        messages.css('height', 'calc(90vh - ' + $(this).height() + 'px' + ($(document).find('body').width() <= 768 ? ' - 5px' : ' - 65px') + ')')
        updateScroll(messages)
    })
}

function loadChat(e) {
    let pane = panes.find('.tab-pane.active');
    chatOverviewContainer.find('.header-chat-overview').addClass('d-none');

    $(e.target).find('.badge').remove();
    if ($(document).find('body').width() <= 768) {
        colChatOverview.addClass('d-none').removeClass('d-block')
        colChat.removeClass('d-none').addClass('d-block')
    }

    if (window.location.href.includes('/admin/chats/booking') || window.location.href.includes('/admin/chats/info') || window.location.href.match(/\/admin\/chats\/archive\/(booking|info)/) || window.location.href.includes('/chat/')) {
        history.pushState({}, null, window.location.href
            .replace(/\d{4}-\d{6}/, pane.data('requestId'))
            .replace(/(chat|chats\/archive|chats)\/[^\/]+/, "$1/" + pane.data('requestType')));
    } else if (window.location.href.includes('admin/chats')) {
        history.pushState({}, null, window.location.href + '/' + pane.data('requestType') + '/' + pane.data('requestId'));
    }

    if (pane.find('.chatPlaceholder').length > 0) {
        $.get({
            url: chatOverview.data('route-chat-show').replace('booking', pane.data('request-type')).replace(10, pane.data('request-id')),
            success: function (result) {
                pane.find('.chatPlaceholder').parent().html(result)
                autoSizeEvent($(document).find('textarea'));
                updateScroll(pane.find('.messages'))
                let chatContainer = $(document).find(pane).find('.chat-container');
                let options = JSON.parse(atob(chatContainer.data('options')))

                if (chatContainer.parent().find('.stateFormContainer').length) {
                    $(document).trigger('new-booking-state-form', chatContainer.parent().find('.stateFormContainer'))
                }

                if (options.checkMessages) {
                    setInterval(() => {
                        checkMessagesAjax(chatContainer);
                    }, checkMessagesInterval);
                }
            }
        })
    } else {
        updateScroll(pane.find('.messages'))
        let chatContainer = pane.find('.chat-container');
        if (pane.find('.chat-container').length) {
            $.get({
                url: JSON.parse(atob(chatContainer.data('options'))).routes.readMessages
            })
        }
    }
}

function sendMessageAjax(_this) {
    if (sending === true) {
        return;
    }
    let chat = $(_this).closest('.chat-container');
    let options = JSON.parse(atob(chat.data('options')));

    if (chat.find('.message-input textarea').val().length) {
        let spinner = chat.find('.spinner-border').slideDown();
        sending = true;
        $.ajax(options.routes.addMessage, {
            type: 'POST',
            dataType: 'JSON',
            processData: false,
            contentType: false,
            data: chat.find('.message-input form').getFormDataAssociative(),
            success: (result) => {
                formatIncomingMessage(chat, result, options)
                chat.find('.chat-message-attachment-labels .badge').remove();
                chat.find('.message-input form')[0].reset();
                chat.find('.message-input input[type="hidden"]').val('');

                // dashboard#2517
                if (result.filteredWords !== null) {
                    let wordList = $('#chat-filtered-words-modal-list');
                    if (wordList.length) {
                        wordList.html('');

                        // dashboard#2517
                        // for (const wordKey in result.filteredWords) {
                        // if (result.filteredWords.hasOwnProperty(wordKey)) wordList.append(`<li>${result.filteredWords[wordKey]}</li>`);
                        // }

                        // Show custom explanations based on what was wrong.
                        wordList.closest('.modal').find('.custom-explanation,.custom-icon').addClass('d-none');
                        if (result.contains_phone == true) {
                            $('#phone-explanation,#phone-icon').removeClass('d-none')
                        } else {
                            if (result.contains_website == true) {
                                $('#website-explanation,#website-icon').removeClass('d-none')
                            } else {
                                if (result.contains_accommodation == true) {
                                    $('#accommodation-explanation,#accommodation-icon').removeClass('d-none')
                                } else {
                                    if (result.contains_email == true) {
                                        $('#email-explanation,#email-icon').removeClass('d-none')
                                    }
                                }
                            }
                        }

                        // Show modal.
                        wordList.closest('.modal').modal('show');
                        window.hideAllTooltips();
                    }
                }
            },
            error: (error) => {
                handleError(chat, error, options)
            },
            complete: () => {
                sending = false;
                spinner.slideUp();
                $('.message-attachment-wrapper').fadeOut(100);
            }
        });
    } else {
        let messages = chat.find('.messages')
        let messagePlaceholder = messages.find('.message-placeholder');
        let messagePrototype = chat.find('.message-prototype .message-container');
        let datePrototype = chat.find('.date-prototype .date');
        let message = messagePrototype.clone();

        let date = moment();
        options.lastDate.datetime = date.format('YYYY-MM-DD HH:mm:ss').toString();

        /** Add date badge above new message if not same date */
        if (options.lastDate.formatted !== date.format('DD-MM-YY')) {
            let newDate = datePrototype.clone();
            newDate.find('.badge').text(date.format('DD-MM-YY'));
            options.lastDate.formatted = date.format('DD-MM-YY').toString();
            appendToMessages(messages, newDate);
        }

        if (messagePlaceholder.length) {
            messagePlaceholder.fadeOut();
            messagePlaceholder.remove();
        }

        message.find('.message').removeClass('alert-success').addClass('alert-danger').addClass('error')
        message.find('.text').html(strip(options.translations.emptyMessage).replace(/[\n\r]/gm, '<br>'));
        message.find('.timestamp').text(date.format('HH:mm'));
        messages.find('.error').remove();
        appendToMessages(messages, message);
        updateScroll(messages);
    }
}

function checkMessagesAjax(chat) {
    let options = JSON.parse(atob(chat.data('options')));

    $.ajax({
        url: options.routes.checkMessages, method: 'POST', dataType: 'JSON', data: {
            datetime: options.lastDate.datetime
        }, success: (result) => {
            if (result.messages) {
                for (let k in result.messages) {
                    if (result.messages.hasOwnProperty(k)) {
                        let data = {
                            item: result.messages[k], message: result.message
                        }
                        formatIncomingMessage(chat, data, options)
                    }
                }
            }
        }, error: (error) => {
            handleError(chat, error, options)
        }
    })
}

function formatIncomingMessage(chat, result, options, approval = false) {
    let messages = chat.find('.messages')
    let message;
    let admin = window.location.pathname.includes('/admin/');

    /** Load prototype for incoming message */
    if (admin && result.item.type === 'owner' || !admin && result.item.type === 'guest' || approval) {
        message = chat.find('.message-prototype .message-container').clone();
    } else {
        message = chat.find('.message-incoming-prototype .message-container').clone();
    }

    let infoMessage = null;
    if (result.item.contains_viewing && (!admin && result.item.type === 'guest') && result.has_360_tour) {
        infoMessage = chat.find('.message-prototype-info .message-container').clone();
    }

    let insuranceMessage = null;
    if (result.item.contains_insurance && (admin && result.item.type === 'guest')) {
        insuranceMessage = chat.find('.message-prototype-info .message-container').clone();
    }

    let date = moment();
    options.lastDate.datetime = date.format('YYYY-MM-DD HH:mm:ss').toString()

    /** Add date badge above new message if not same date */
    if (options.lastDate.formatted !== date.format('DD-MM-YY')) {
        let newDate = chat.find('.date-prototype .date').clone();
        newDate.find('.badge').text(date.format('DD-MM-YY'));
        options.lastDate.formatted = date.format('DD-MM-YY').toString();
        appendToMessages(messages, newDate);

        if (infoMessage) {
            appendToMessages(messages, infoMessage);
        }

        if (insuranceMessage) {
            appendToMessages(messages, insuranceMessage);
        }
    }

    for (let mk in result.item.attachments) {
        if (result.item.attachments.hasOwnProperty(mk)) {
            message.find('.attachments')
                .append('<a href="' + result.item.attachments[mk].path + '" class="badge badge-primary fa-1x mr-1" target="_blank">' + result.item.attachments[mk].name + '</a>');
        }
    }

    if (messages.find('.message-placeholder').length) {
        messages.find('.message-placeholder').fadeOut().remove();
    }

    if (result.item.type === 'system') {
        let chatMessage = result.item.message;
        let status = chat.find('.date-prototype .date').clone();
        status.find('.badge').text(chatMessage.title);

        // status.find('.badge').text("{{ __('chats.Booking') }}");
        appendToMessages(messages, status);

        message.find('.text').html(formatMessage(chatMessage.message));
    } else {
        message.find('.text').html(formatMessage(result.item.message))
    }

    message.find('.timestamp').append(date.format('HH:mm'));
    appendToMessages(messages, message);
    /** Update options data */
    chat.data('options', btoa(JSON.stringify(options)));
    updateScroll(messages);

    if (infoMessage) {
        infoMessage.find('.text').html(result.contains_viewing_guest_message);
        infoMessage.find('.timestamp').append(date.format('HH:mm'));
        appendToMessages(messages, infoMessage);
        updateScroll(messages);
    }
}

function formatMessage(message) {
    return message.replace(/<(?!\/?(u|a)\s*\/?)[^>]+>/gm, '').replace(/[\n]/gm, '<br>');
}

function handleError(chat, error, options) {
    let messages = chat.find('.messages')
    let message = chat.find('.message-prototype .message-container').clone();
    let date = moment();
    options.lastDate.datetime = date.format('YYYY-MM-DD HH:mm:ss').toString()

    /** Add date badge above new message if not same date */
    if (options.lastDate.formatted !== date.format('DD-MM-YY')) {
        let datePrototype = chat.find('.date-prototype .date');
        let newDate = datePrototype.clone();
        newDate.find('.badge').text(date.format('DD-MM-YY'));
        options.lastDate.formatted = date.format('DD-MM-YY').toString();
        appendToMessages(messages, newDate);
    }

    if (messages.find('.message-placeholder').length) {
        messages.find('.message-placeholder').fadeOut().remove();
    }

    let messageText = '';
    message.find('.message').removeClass('alert-success').addClass('alert-danger').addClass('error');
    if (error.status === 422 && Object.keys(error.responseJSON.errors).some(e => /attachments\.\d+/gi) && error.responseJSON?.error_type === 'virus_scan') {
        messageText = options.translations.virusError;
    } else if (error.status === 413 || error.status === 422 && Object.keys(error.responseJSON.errors).some(e => /attachments\.\d+/gi)) {
        messageText = options.translations.validationError;
    } else {
        messageText = options.translations.error;
    }

    message.find('.text').html(messageText.replace(/[\n\r]/gm, '<br>'));
    message.find('.timestamp').text(date.format('HH:mm'));
    messages.find('.error').remove();
    appendToMessages(messages, message);
    updateScroll(messages);
}


function checkMobileView() {
    if ($(document).find('body').width() <= 768) {
        colChatOverview.addClass('d-none').removeClass('d-block')
        colChat.removeClass('d-none').addClass('d-block')
        window.backbuttonListener.addListener('back-button', () => {
            $('button.backButton').click();
        }, true);
    } else {
        colChatOverview.addClass('d-block').removeClass('d-none')
        colChat.addClass('d-block').removeClass('d-none')
    }
}

// Check and handle extra parameters.
const checkForParameters = () => {
    const url = new URL(window.location.href);
    const params = url.searchParams;

    // After a Mollie payment, this parameter is set to show the cancellation insurance modal directly.
    if (params.get('payment') === 'success') {
        params.delete('payment');
        window.history.replaceState({}, '', url.toString());
        $('#payment-success-modal #success-next').off('click keydown').on('click keydown', function() {
            $('#payment-success-modal').modal('hide');
            $('.tab-pane.show.active button.insuranceCallToAction').click();
        });
        $('#payment-success-modal').modal('show');
        window.hideAllTooltips();
    }

};
$(document).ready(() => {
    checkForParameters();
});
